import React from 'react'

const StatusOutlineIcon16pxSvg = (props) => {
    return (
        <svg 
        {...props}
        xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g clipPath="url(#clip0_139_22866)">
                <path d="M2.678 12.343C2.7818 12.4472 2.86133 12.573 2.91094 12.7114C2.96055 12.8499 2.97901 12.9976 2.965 13.144C2.89472 13.8216 2.76148 14.4911 2.567 15.144C3.962 14.821 4.814 14.447 5.201 14.251C5.4205 14.1398 5.67329 14.1135 5.911 14.177C6.59243 14.3586 7.29477 14.4501 8 14.449C11.996 14.449 15 11.642 15 8.44897C15 5.25697 11.996 2.44897 8 2.44897C4.004 2.44897 1 5.25697 1 8.44897C1 9.91698 1.617 11.279 2.678 12.343ZM2.185 16.248C1.94807 16.2949 1.71037 16.3379 1.472 16.377C1.272 16.409 1.12 16.201 1.199 16.015C1.28779 15.8056 1.36918 15.5931 1.443 15.378L1.446 15.368C1.694 14.648 1.896 13.82 1.97 13.049C0.743 11.819 0 10.209 0 8.44897C0 4.58297 3.582 1.44897 8 1.44897C12.418 1.44897 16 4.58297 16 8.44897C16 12.315 12.418 15.449 8 15.449C7.20765 15.45 6.41859 15.3472 5.653 15.143C5.133 15.406 4.014 15.885 2.185 16.248Z" fill="#171717" />
            </g>
            <defs>
                <clipPath id="clip0_139_22866">
                    <rect width="16" height="16" fill="white" transform="translate(0 0.448975)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default StatusOutlineIcon16pxSvg